import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import styles from "./styles.m.css";
import AudioCollectionCard from "../../atoms/audio-collection-card";
import { LoadmoreAudiostories } from "../../../api";

const VikatanPlayHome = ({ collection, numberOfCardsInViewDesktop = 3, accentColor }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const collectionSlug = "vikatan-play-latest-audiobooks";
    const limit = 4;
    const offset = 0;

    LoadmoreAudiostories(collectionSlug, limit, offset)
      .then(items => {
        setItems(items.items);
      })
      .catch(error => {
        console.error("Error fetching VikatanPlayStories:", error);
      });
  }, []);

  if (!items || !items.length) {
    return null;
  }

  const mainCollection = (
    <div className={styles["main-collection"]}>
      <div className={styles["download-icon"]}>
        <a href="https://onelink.to/r62hmj" target="_blank" rel="noopener noreferrer">
          <img src="https://media.vikatan.com/vikatan/2025-08-29/vqz33hf3/download-icon-2x.png?format=webp&w=53&q=90" />
        </a>
      </div>

      <div className={styles["main-collection-content"]}>
        <div>
          <div className={styles["vikatan-play-mobile"]}>
            <img src="https://media.vikatan.com/vikatan/2025-08-26/xuclg556/play-logo.png" alt="" />
          </div>

          <div className={`${styles["vikatan-play-scanner"]} hidden-mobile`}>
            <img src="https://images.assettype.com/vikatan/2025-08-29/sztz2mqd/onelinktor62hmj.png" alt="" />
          </div>
        </div>

        <div className={styles["text-wrapper"]}>
          <div className={`${styles["bundle-text"]} hidden-mobile`}>
            <h2 className={styles["headline"]}>விகடனின் கிளாசிக் படைப்புகள் இப்போது ஆடியோ புத்தகங்களாக!</h2>
            <p className={styles["description"]}>
              விகடன் App-ஐ இன்ஸ்டால் செய்து ஆடியோ புத்தகங்களை இலவசமாக கேட்டு மகிழ்ந்திடுங்கள்!
            </p>
          </div>
          <div className={styles["install-app"]}>
            <a
              href="https://onelink.to/r62hmj"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["install-app-link"]}
            >
              <span>Install App</span>
              <div className={styles["install-app-ios"]}>
                <img
                  src="https://media.vikatan.com/vikatan/2025-08-29/ac4kp7t0/vikatanplay-app-store-2x.png?format=webp&w=43&q=100"
                  alt=""
                />
              </div>
              <div className={styles["install-app-android"]}>
                <img
                  src="https://media.vikatan.com/vikatan/2025-08-29/eran5dh0/vikatanplay-android-2x.png?format=webp&w=41&q=100"
                  alt=""
                />
              </div>
            </a>
          </div>
        </div>

        <div className={`${styles["vikatan-play-mobile-image"]} hidden-desktop`}>
          <img src="https://media.vikatan.com/vikatan/2025-08-28/c416c14a/vikatan-app-mobile.png" alt="" />
        </div>
      </div>

      <div className={`${styles["store-icons"]} hidden-mobile`}>
        <h5>Available on the App Store and Google Play.</h5>
        <a href="https://onelink.to/r62hmj" target="_blank" rel="noopener noreferrer">
          <img src="https://media.vikatan.com/vikatan/2025-08-26/zjfpg138/app-store-2x.png?format=webp&w=153&q=100" />
        </a>
        <a href="https://onelink.to/r62hmj" target="_blank" rel="noopener noreferrer">
          <img src="https://media.vikatan.com/vikatan/2025-08-26/ghapv5ve/play-store-2x.png?format=webp&w=153&q=100" />
        </a>
      </div>
    </div>
  );

  const itemsList = items.slice(0, 6).map((item, index) => {
    return (
      <AudioCollectionCard
        key={item.id}
        collection={item}
        className={`${styles.card} ${index === 0 ? styles["first-item"] : ""}`}
        showTitleAndMetaDesc={true}
        numberOfCardsInViewDesktop={numberOfCardsInViewDesktop}
        VikatanPlayHome={true}
      />
    );
  });

  return (
    <div className={`${styles["bundle-wrapper"]} container`}>
      <div className={styles.base} style={accentColor && { "--accent-color": accentColor }}>
        <div className={`${styles["carousel-wrapper"]}`}>
          <div>{mainCollection}</div>
          <div className={`${styles["headline-mobile"]} hidden-desktop`}>
            <h3 className={styles["headline"]}>விகடனின் கிளாசிக் படைப்புகள் இப்போது ஆடியோ புத்தகங்களாக!</h3>
          </div>

          <div className={`${styles["bundle-mobile-content"]} hidden-desktop`}>
            <p className={styles["description"]}>
              விகடன் App-ஐ இன்ஸ்டால் செய்து ஆடியோ புத்தகங்களை இலவசமாக கேட்டு மகிழ்ந்திடுங்கள்!
            </p>
            <div className={`${styles["store-icons"]} hidden-desktop`}>
              <h5>Available on the App Store and Google Play.</h5>
              <a href="https://onelink.to/r62hmj">
                <img src="https://media.vikatan.com/vikatan/2025-08-26/zjfpg138/app-store-2x.png?format=webp&w=153&q=100" />
              </a>
              <a href="https://onelink.to/r62hmj">
                <img src="https://media.vikatan.com/vikatan/2025-08-26/ghapv5ve/play-store-2x.png?format=webp&w=153&q=100" />
              </a>
            </div>
          </div>
          <div className={styles["other-collection"]}>{itemsList}</div>
        </div>
      </div>
    </div>
  );
};

VikatanPlayHome.propTypes = {
  accentColor: PropTypes.string,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default VikatanPlayHome;
